// Utilities
import { defineStore } from 'pinia'

import { User } from '@/types/user'
import { Bugsnag } from '@/plugins/bugsnag'

interface UserState {
  businessProfileUsers: User[]
  user: User | null
}

export const useUserStore = defineStore('user', {
  state: (): UserState => ({
    user: null,
    businessProfileUsers: []
  }),
  getters: {
    getUser(): User | null {
      return this.user
    }
  },
  actions: {
    setUser(user: User | null) {
      this.user = user
      Bugsnag.setUser(user?.id.toString(), user?.emailAddress, user?.fullName)
    },
    setBusinessProfileUsers(users: User[]): void {
      this.businessProfileUsers = users.sort((a, b) =>
        a.fullName.localeCompare(b.fullName)
      )
    }
  }
})
